import { STATUS_META } from "../lib/status";

export const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_home-services-api/artifacts/prndpuff_Luxurio%20Logo%20PNG.png";

export function StatusBadge({ status }) {
    const meta = STATUS_META[status] || { label: status, color: "#666" };
    return (
        <span
            data-testid={`status-badge-${status}`}
            className="inline-flex items-center gap-1.5 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.15em] border"
            style={{
                color: meta.color,
                borderColor: meta.color + "44",
                backgroundColor: meta.color + "14",
            }}
        >
            <span
                className="w-1.5 h-1.5 rounded-full"
                style={{ background: meta.color }}
            />
            {meta.label}
        </span>
    );
}

export function GoldDivider({ className = "" }) {
    return (
        <div
            className={`h-px w-16 bg-gradient-to-r from-[#D4AF37] to-transparent ${className}`}
        />
    );
}

export function KPI({ label, value, sub, testid }) {
    return (
        <div
            data-testid={testid}
            className="lx-card-dark p-6 group transition-all duration-500 hover:border-[#D4AF37]/40"
        >
            <div className="lx-label text-[#A09BA5] mb-3">{label}</div>
            <div className="font-serif text-4xl text-white tracking-tight">
                {value}
            </div>
            {sub && (
                <div className="text-xs text-[#A09BA5] mt-2">{sub}</div>
            )}
        </div>
    );
}

export function Spinner({ className = "" }) {
    return (
        <div
            className={`inline-block w-5 h-5 border-2 border-[#D4AF37] border-t-transparent rounded-full animate-spin ${className}`}
        />
    );
}

export function Brand({ light = false, size = "default" }) {
    // Render the actual Luxurio Edge logo image, transparent (no backdrop).
    // A light brightness/contrast boost on dark surfaces keeps the artwork
    // legible without adding a chip.
    const heights = {
        small: "h-10 md:h-12",
        default: "h-11 md:h-14",
        medium: "h-12 md:h-16",
        large: "h-14 md:h-20",
        hero: "h-16 md:h-24",
    };
    const h = heights[size] || heights.default;
    const lightStyle = light
        ? {
              filter:
                  "brightness(1.35) contrast(1.15) drop-shadow(0 0 6px rgba(212,175,55,0.55))",
          }
        : undefined;
    return (
        <div className="flex items-center select-none" data-testid="brand-logo">
            <img
                src={LOGO_URL}
                alt="Luxurio Edge — Technical Services"
                className={`${h} w-auto block`}
                style={lightStyle}
                draggable={false}
            />
        </div>
    );
}

export function Empty({ title, subtitle, action }) {
    return (
        <div className="text-center py-16 px-6">
            <div className="font-serif text-2xl text-[#180A21] mb-2">{title}</div>
            {subtitle && (
                <p className="text-sm text-[#555] max-w-md mx-auto mb-6">
                    {subtitle}
                </p>
            )}
            {action}
        </div>
    );
}
